/**
 * RuleSelectField — labelled closed-vocabulary dropdown for the automation-rule
 * builder (SE-5506). Presentational only.
 * @module features/player-kanban/components/molecules/RuleSelectField
 */

export { default } from "./RuleSelectFieldView";
export type {
  RuleSelectFieldViewProps,
  RuleSelectOption,
} from "./RuleSelectFieldView";
